module.exports = __webpack_public_path__ + "static/media/About1.d1aea017.jpg";